import { Application } from 'src/portaljs/constants/application';
import * as _ from 'lodash-es';


/** ---------------------------------------------------------------------- */
export interface IUnifiedSettingsDistrictModel {
    districtAppId: string;
    districtLogoUrl: string;
    siteSettings: {siteGuid: string, siteLogoUrl: string}[];
    districtHomePage?: IDistrictHomePageModel;
    scopes?: object;
}


/** ---------------------------------------------------------------------- */
export interface IUnifiedSettingsUserModel {
  userGuid: string;
  globalSettings: {
    profilePictureUrl?: string;
    preferredSite: string;
    preferredApp: Application;
    trackLastSite?: boolean;
    trackLastApp?: boolean;
  };
  portalSettings: {
    lastApp: Application;
    lastSite: string;
  }
}
/** ---------------------------------------------------------------------- */
export interface IDistrictHomePageModel {
    enabled?: boolean;
    data?: string; // loaded via dataUrl
    dataUrl?: string;
    updated?: Date;
    updatedBy?: string;

}




/** ---------------------------------------------------------------------- */
export class UnifiedSettingsDistrictModel {
  private settings: IUnifiedSettingsDistrictModel;

  public constructor(settings: IUnifiedSettingsDistrictModel) {
    this.settings = settings;
  }

  public getSettings(): IUnifiedSettingsDistrictModel {
    return this.settings;
  }

  public getDistrictLogo(): string {
    return this.settings?.districtLogoUrl;
  }
  public getSiteLogo(siteGuid: string): string {
    const settings = _.get(this.settings, 'siteSettings', []);
    return settings.find(s => s.siteGuid === siteGuid)?.siteLogoUrl;
  }

  public getHomePageDataUrl(): string {
    return this.settings?.districtHomePage?.dataUrl;
  }
  public getHomePageData(): string {
    return this.settings?.districtHomePage?.data;
  }

  public getScopes(): object {
    return this.settings?.scopes || {};
  }
}



/** ---------------------------------------------------------------------- */
export class UnifiedSettingsUserModel {
  private settingsData: IUnifiedSettingsUserModel;

  public constructor(settings: IUnifiedSettingsUserModel) {
    this.settingsData = settings;
  }

  public getSettings(): IUnifiedSettingsUserModel {
    return this.settingsData;
  }

  public getUserGuid(): string {
    return _.get(this.settingsData, ['userGuid']);
  }
  public getPreferredSiteGuid(): string {
    return _.get(this.settingsData, ['globalSettings', 'preferredSiteGuid']);
  }
  public getPreferredApp(): Application {
    return _.get(this.settingsData, ['globalSettings', 'preferredApp']);
  }
  public getProfilePictureUrl(): string {
    return _.get(this.settingsData, ['globalSettings', 'profilePictureUrl']);
  }

  public isTrackingLastSite(): boolean {
    return _.get(this.settingsData, ['globalSettings', 'trackLastSite']) === true;
  }
  public isTrackingLastApp(): boolean {
    return _.get(this.settingsData, ['globalSettings', 'trackLastApp']) === true;
  }
  public setTrackingLastSite(trackLast: boolean) {
    return _.set(this.settingsData, ['globalSettings', 'trackLastSite'], trackLast);
  }
  public setTrackingLastApp(trackLast: boolean) {
    return _.set(this.settingsData, ['globalSettings', 'trackLastApp'], trackLast);
  }


  public getLastApp(): Application {
    return _.get(this.settingsData, ['portalSettings', 'lastApp']);
  }
  public setLastApp(app: Application): void {
    _.set(this.settingsData, ['portalSettings', 'lastApp'], app);
  }

  public getLastSite(): string {
    return _.get(this.settingsData, ['portalSettings', 'lastSite']);
  }
  public setLastSite(siteGuid: string): void {
    _.set(this.settingsData, ['portalSettings', 'lastSite'], siteGuid);
  }
}


